import React, { useMemo } from 'react';
import CSSModules from 'react-css-modules';
import * as PropTypes from 'prop-types';
import get from 'lodash/get';

import { INVITATION_TYPES } from '../../../../constants';
import SimpleAvatar from '../../../common/SimpleAvatar';
import { getFullName } from '../../utils';
import styles from './styles.styl';

function getRole({ type, careRole } = {}, formatMessage) {
  switch (type) {
    case INVITATION_TYPES.FAMILY_MEMBER:
      return formatMessage({ id: 'circles.roles.family_member' });
    case INVITATION_TYPES.CAREGIVER:
      return formatMessage({ id: 'circles.roles.caregiver' });
    case INVITATION_TYPES.GUARDIAN_PROXY: {
      const i18n = careRole
        ? `circles.roles.${careRole}`
        : 'circles.roles.guardianProxyShort';

      return formatMessage({ id: i18n });
    }
    default:
      return '';
  }
}

function InvitationListItem({ invitation, formatMessage, onClick, className }) {
  const name = getFullName(get(invitation, 'targetUser'));
  const avatar = get(invitation, 'targetUser.avatar.thumbMin');
  const role = getRole(invitation, formatMessage);

  const subTitle = useMemo(
    () =>
      formatMessage(
        { id: 'healthboard.invitations.card.subTtitle' },
        { role, name },
      ),
    [role, name],
  );

  const title = useMemo(
    () => formatMessage({ id: 'healthboard.invitations.card.title' }, { name }),
    [name],
  );

  return (
    <div styleName="root" className={className} onClick={onClick}>
      <div styleName="left">
        <SimpleAvatar src={avatar} text={name} size={36} bordered />
      </div>
      <div styleName="right">
        <p styleName="meta">{subTitle}</p>
        <p styleName="strong">{title}</p>
      </div>
    </div>
  );
}

InvitationListItem.propTypes = {
  invitation: PropTypes.object,
  formatMessage: PropTypes.func,
  className: PropTypes.string,
  onClick: PropTypes.func,
};

export default CSSModules(InvitationListItem, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/Healthboard/Components/InvitationListItem/index.jsx